/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BroadcastMessageRequestModel } from '../../models/broadcast-message-request-model';

export interface AnonymousBroadcastMessagesPost$Params {
      body?: BroadcastMessageRequestModel
}

export function anonymousBroadcastMessagesPost(http: HttpClient, rootUrl: string, params?: AnonymousBroadcastMessagesPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, anonymousBroadcastMessagesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<string>>;
    })
  );
}

anonymousBroadcastMessagesPost.PATH = '/Anonymous/BroadcastMessages';
